import { ScrollPage } from '@optools/components/layout/layout';
import { Button } from '@optools/components/ui/button';
import { CreateEsniRule } from '@optools/tools/esni/components/rules/create-esni-rule';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

/* eslint-disable perfectionist/sort-objects */
export const Route = createFileRoute('/_auth/esni/rules/create')({
  component: RouteComponent,
  beforeLoad: authorizedRouteLoader('esni.rules.create', {
    unauthorizedRedirect: '/esni/rules',
  }),
});

export function RouteComponent() {
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <ScrollPage>
      <div className="mx-auto grid max-w-2xl gap-6">
        <div className="flex flex-col gap-2">
          <Button asChild className="-ml-2 w-fit" variant="ghost">
            <Link to="/esni/rules">
              <ArrowLeft className="mr-2 size-4" />
              Back to rules
            </Link>
          </Button>
          <h1 className="text-lg font-semibold">Create ESNI Rule</h1>
          <p className="sr-only">Create a new ESNI rule to control asset access</p>
        </div>
        <CreateEsniRule
          onCancel={() => {
            navigate({ to: '/esni/rules' });
          }}
          onCreated={() => {
            navigate({ to: '/esni/rules' });
          }}
        />
      </div>
    </ScrollPage>
  );
}
